import { Component, EventEmitter, Inject, Output, Renderer2 } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PopupSaveAndCancel } from '@my-models/api-model';

@Component({
  selector: 'app-post-property-success',
  templateUrl: './post-property-success.component.html',
  styleUrls: ['./post-property-success.component.css']
})
export class PostPropertySuccessComponent {
  @Output() ClosePopUp: EventEmitter<any> = new EventEmitter<any>();
  pageObjet: PopupSaveAndCancel = {
    Save: false,
    data: null
  };

  closeModal(isSave: boolean = false){
    this.ClosePopUp.emit(this.pageObjet);
  }
}
